import { FC, memo } from "react";
import { Skeleton } from '@mui/material';
import { Box } from '@mui/system';
import { LiSeparator, List, ListItem } from "../../patient-profile-widget.styles";
import { DotSeparatedSkeleton } from "../../shared/skeleton/dot-separated-skeleton";
import { randomBetween } from "../../utils/random-between";

export const VisitsSkeleton: FC = memo(() => {
  const itemCount = 5;

  const noteString = () => <Skeleton variant="rounded" width={randomBetween(130, 200)} height={14} sx={{ marginTop: '4px' }} />

  const noteItem = (key: number) => {
    return <>
      <ListItem key={key}>
        <Box sx={{ display: 'flex', alignItems: 'start', flexDirection: 'row' }}>
          <Skeleton variant="circular" width={34} height={34} sx={{ marginRight: '12px' }} />
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <DotSeparatedSkeleton />
            <Box>{noteString()}</Box>
          </Box>
        </Box>
      </ListItem>
      {key !== itemCount - 1 && <LiSeparator key={1000 + key} />}
    </>
  }

  return <List>
    {Array.from({ length: itemCount }, (_, index) => noteItem(index))}
  </List>
});